import { View } from "@-/com.npmjs.react-native";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { ComponentProps } from "react";

type TextProps = ComponentProps<typeof Text>;

/**
 * Slide-content widgets that sit inside a table cell. The table grid itself is
 * `@bacons/mdx`'s built-in table components (see {@link ./bacons-table}), which
 * map directly from GFM `table`/`tr`/`td` — these two are just the cell payloads
 * the pinyin/character slides info by name.
 */

/** Small filled circle for the tone-color column (matches the settings swatches). */
export function SlideToneSwatch({ color, label }: { color: string; label?: string }) {
  return (
    <View className="flex-row items-center gap-2">
      {/* eslint-disable-next-line react-native/no-inline-styles -- tone hex is data, not a theme token */}
      <View className="size-4 rounded-full" style={{ backgroundColor: color }} />
      {label != null ? (
        <Text className="text-sm" selectable>
          {label}
        </Text>
      ) : null}
    </View>
  );
}

/** Large CJK glyph for a character column. */
export function SlideGlyph(props: TextProps) {
  return <Text className="text-2xl text-foreground" selectable variant="glyph" {...props} />;
}
